import { populate } from 'populate';
import dragonBones from 'pixi-dragonbones';

const raw = {
    className: 'WorldLayout23',
    width: 0,
    height: 0,
    x: 50,
    y: 100,
    list: [
        {
            id: '1',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: '2',
            type: 'Container',
            name: 'backgrounds',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '3',
            type: 'Container',
            name: 'nodesContainer',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '4',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '5',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '1',
            data: '',
        },
        {
            id: '6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_1',
            parent: '2',
            data: '',
        },
        {
            id: '7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1352,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_2',
            parent: '2',
            data: '',
        },
        {
            id: '99114578-0adf-4520-949f-d0c07648e244',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1352,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_2',
            parent: '2',
            data: '',
        },
        {
            id: 'c40c6093-5cd4-4365-8df8-0d20f93a0222',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1352,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_2',
            parent: '2',
            data: '',
        },
        {
            id: '8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2704,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_3',
            parent: '2',
            data: '',
        },
        {
            id: '10',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5408,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_5',
            parent: '2',
            data: '',
        },
        {
            id: '9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4056,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_4',
            parent: '2',
            data: '',
        },
        {
            id: '11',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6760,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_6',
            parent: '2',
            data: '',
        },
        {
            id: '12',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8112,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_7',
            parent: '2',
            data: '',
        },
        {
            id: '13',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9464,
            y: 0,
            anchor: {
                x: 0,
                y: 0,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'map23_export_8',
            parent: '2',
            data: '',
        },
        {
            id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 251,
            y: 447,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'baa6dd6b-b5e8-419d-9892-6c637c0781b0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 337,
            y: 487,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3bb8cfad-ec70-4025-86d5-ca682c108d7b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 357,
            y: 567,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a9b7b0af-0ad0-473a-84a9-c7d83c80e392',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 451,
            y: 589,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7606d46f-35a0-480b-8a6c-36fa1887dce8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 540,
            y: 547,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f0a79483-7ecc-4e50-b832-d0a0025593c4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 622,
            y: 497,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f4b02f23-91f8-4dcb-b687-ed7574eb01a7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 691,
            y: 438,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b735ebbf-1fad-4dc6-b190-634aa204a8c8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 764,
            y: 380,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '804c69f6-58ba-411d-a648-1b3dd2694ba9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 840,
            y: 325,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f73ed37a-dbb7-4fcd-b880-be63fc93e033',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 926,
            y: 285,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '39bfe8e7-d9df-44f6-b9b6-370b4562cd75',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1021,
            y: 261,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'abfd17fb-6549-4f3f-812d-8a528aa637c9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1118,
            y: 253,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '58ca9774-f966-4a22-a0df-a7c67fad732e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1212,
            y: 271,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd7617b08-e6cf-428c-ac2f-0b73664ddede',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1304,
            y: 297,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1e4333a0-7c12-4c06-a9a5-c80eb6f5a288',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1398,
            y: 320,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '343e68cc-d3b4-4ae2-8ccc-5cc540a3dd1e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1494,
            y: 306,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a2491706-8900-45a9-a7e2-2024b344b6d0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1589,
            y: 332,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '41adcf45-2e15-49aa-aee9-baaf5725471f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1678,
            y: 378,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '89f545d8-dd8b-4244-94e1-10ef0778abdb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1778,
            y: 374,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fce12b84-dca3-44d0-bf6c-6e729e8501a6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1873,
            y: 353,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '6b01ee90-784d-4632-9a73-b6f46f7a4c38',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1963,
            y: 314,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0d11700a-d0c2-4424-9ebe-28cd2d852da1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2047,
            y: 264,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0e98334f-a5f3-4cf5-b0b5-a9603c4ef85f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2128,
            y: 211,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'cd2df21f-91a0-43fc-9f9c-57ef321ebc69',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2216,
            y: 169,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4f2d9690-fb35-46b8-b457-1a4e513a5e45',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2312,
            y: 141,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '71e12bd8-0055-49a2-875a-fb683989c99b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2413,
            y: 160,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '56a4d4bc-583b-4dcb-bdc2-1375617db2e2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2495,
            y: 212,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '06a9f11d-f676-435c-a0f4-abca8e3819df',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2558,
            y: 282,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '2d076ef3-92a1-44ea-99d1-a8ca43a2de79',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2608,
            y: 358,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '5853cb19-8576-4a85-b040-7d14d773910f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2662,
            y: 434,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ebacb577-e876-45ee-bf65-5bbd12f34ccf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2722,
            y: 505,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3abdd0d4-2f2f-45ad-8476-02e411fa2a51',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2811,
            y: 547,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8462f301-f74d-4b0e-84d8-9a349874a91d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2912,
            y: 526,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e2d3735b-2a47-407b-bde6-256443ab1544',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3004,
            y: 480,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '01f485b1-4b06-4225-8b85-7f7801e4b2c7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3088,
            y: 428,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ff6dc625-5580-49bc-bee3-15d0da4ee04e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3168,
            y: 373,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '853ec172-f7fe-4b6b-9965-48357ce7252d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3251,
            y: 319,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '319434c0-7be1-4e45-bba7-a60593d0a7ed',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3346,
            y: 285,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a5af70c2-e430-4b80-8c4a-79c8decfbd26',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3445,
            y: 254,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'acba4486-8d38-4730-8b49-c86b1f95f2cc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3547,
            y: 234,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f482c54a-a3a9-4c36-b19e-1841585b4f64',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3651,
            y: 225,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '69739439-67b7-4cce-8819-412f526533b4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3755,
            y: 226,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3862f4c8-d941-4d73-8d0f-fda81aa97d65',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3855,
            y: 255,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ae7033b5-5c02-4eae-9ea6-be47a90c7c08',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3938,
            y: 308,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd60f167a-4444-4334-9743-3c3a624659f5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4003,
            y: 376,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9775f23d-c103-4c7d-aae5-0c8e8c6d4012',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4072,
            y: 440,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '9da6f398-8821-4ada-ad9d-4a2685d1dfbb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4149,
            y: 501,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '334037e4-6a53-49ae-aeb0-2c3890c7d3c5',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4236,
            y: 550,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c9b7f75d-b9a8-4e5c-8f5f-a6f443964295',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4338,
            y: 563,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fcdb26f0-71ef-400c-b0c4-882fc793128f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4428,
            y: 520,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ca90bb5c-12bf-49dd-a8d8-7467b18f89c7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4496,
            y: 452,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '80334f79-7df8-4892-a5f5-f8d3d80800ac',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4558,
            y: 381,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b93c0117-7e0d-4757-bb49-c9a9d112e0e2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4624,
            y: 314,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8b7f313b-94ee-48b0-a1fa-774eb75bd8ae',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4697,
            y: 249,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1a5c369d-c406-4460-970a-2f9d1f4efa72',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4790,
            y: 204,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c0e29d76-b584-48e9-9f9f-cbfbe93d7189',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4891,
            y: 177,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e244e823-dae1-4b47-8e01-332b8319cda2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4994,
            y: 173,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e323b28c-4ea4-46c7-8124-d2273e1ed827',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5097,
            y: 185,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '52e3a905-4904-45f6-99ad-5c58eacc3c68',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5196,
            y: 219,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'cfa9903a-435c-40cc-8d68-63bbd300871b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5288,
            y: 268,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd1fad76a-6340-4a63-9f65-abde2f13a707',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5371,
            y: 330,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '26907960-bad3-405c-a908-1cf56de2ac0f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5458,
            y: 389,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a52c16cc-ac28-4f69-be9d-4bcbcdf5a066',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5560,
            y: 419,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fcd1edbd-d870-4928-84e4-b9d5e153b135',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5665,
            y: 405,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a7f92d29-18f5-4e87-bf68-e2e9ba6d4d4b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5752,
            y: 354,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '1b7c774a-1776-43ca-9c29-8af36af66c21',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5825,
            y: 289,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd39a394a-6100-4243-a729-82340a9d8909',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5906,
            y: 231,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e89fd95d-f540-4935-aecb-a96043158ee4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5999,
            y: 187,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ba36e56b-1de0-41e1-bd48-4d2eec8e7e1c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6100,
            y: 166,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b0f64b08-1eed-4428-97f3-8f0aa2f75661',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6208,
            y: 178,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7e44e088-095c-441a-9e7a-c3fa11ebdc35',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6304,
            y: 226,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3da48753-a3db-4153-966a-f1702b6290fc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6377,
            y: 292,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4514427b-e3b4-4f95-a086-3b1c85a41413',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6448,
            y: 358,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fa413494-c1aa-4c7e-8a29-22f2fab675d9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6521,
            y: 422,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b7cb3d6b-6cd8-41dc-b71a-69b93f84c794',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6607,
            y: 471,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b5c429e7-aa8d-452e-8542-f5fd933da395',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6702,
            y: 511,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f1b835fc-24d4-4536-8f51-35da452df301',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6800,
            y: 545,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '14e0a8e1-40e0-41ba-a129-9f81fb7e3650',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6903,
            y: 543,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd18566ec-73d0-4046-aab3-8be189e33119',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7004,
            y: 520,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c1e3cab2-92b5-4084-b6b7-5bc5b52f1dbb',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7099,
            y: 486,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f391e78a-3890-450b-b602-e801e65d4c28',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7195,
            y: 447,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c2192c33-51bb-4d17-8833-fa8a3fa1d31a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7286,
            y: 402,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '6c5f4f25-c29b-4195-93f8-3e8ed1f22529',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7377,
            y: 357,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '344e2fce-a2de-46f4-ba75-e6730fb3e25b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7462,
            y: 305,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fe435eee-3b70-4e8e-be7b-461c8d08896a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7557,
            y: 266,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'd056a9e4-7303-4e62-805c-176f0a22fce6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7650,
            y: 228,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'cdd73c52-cb3d-457c-bb0e-be3b2db93ab2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7753,
            y: 218,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '76101281-8b27-497f-a87f-b215cd874834',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7856,
            y: 238,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c461b5d0-09b9-4053-a8ab-7c84b04a973c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7956,
            y: 271,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '825ad149-591a-47e6-ae98-d63af7b882c8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8048,
            y: 319,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7e462c58-ebe6-4357-96b9-c3f09760e55a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8119,
            y: 388,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4d44f821-1672-4074-8f0e-380c4bb5d8c7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8169,
            y: 468,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '2804a81e-f20b-433c-b370-07307d32803c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8245,
            y: 534,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '075b09e3-92c6-4180-8ae6-8a0654376415',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8351,
            y: 541,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4b67c05c-01d2-46e8-8351-071d9a41e12e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8457,
            y: 535,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '0f19d677-7c37-4a5e-a85f-834136d4980e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8557,
            y: 507,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '421858a3-1a30-45ac-82f7-514a99f7d2da',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8651,
            y: 460,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '20f434e4-bf0b-492c-b366-8540b4e5d284',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8741,
            y: 412,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '32b3bc7b-93ef-44aa-b00a-f5c6bbe0412c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8831,
            y: 362,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'fa94e480-d23c-4b03-9065-4fdf3494ca33',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8932,
            y: 337,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'f7bac660-a535-4d8c-b26a-c2568c957b79',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9034,
            y: 360,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8fda854f-ead1-4e9a-886d-161570f583e7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9102,
            y: 419,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '4a798a4b-1e99-43d4-bec1-1c3681f18ce6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9192,
            y: 448,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7e1f4c8e-5af3-4029-bd1d-dac5345d9cad',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9286,
            y: 430,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '410ae7a8-322c-4537-b13e-5bbe831504f4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9366,
            y: 383,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '54ceced5-7b0f-42bb-bb53-0a8614cf1270',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9436,
            y: 326,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '70dc1364-090f-4c1e-8b53-9b0655a34a53',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9502,
            y: 264,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'e8f34ccb-f507-4f3f-8f8f-9a2d959cadaf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9576,
            y: 211,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '171d56ef-eee0-4aaa-9b0c-c20a1ceba7f2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9668,
            y: 188,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'c00068c6-94f5-44b4-910c-657bbce3db20',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9761,
            y: 205,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '048337a4-0c94-4980-97e9-8d0ebeeb545b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9840,
            y: 255,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '3593888b-4934-4aeb-ae52-5988abab5636',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9907,
            y: 315,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'b4617012-0047-4370-b194-c75ff031bb8b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9964,
            y: 380,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '8048d01a-1ed2-487c-ace9-c89c3f50e60a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10026,
            y: 444,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '7133ab0f-c476-4b2c-9e6c-dbe6bf44790e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10096,
            y: 502,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '85be7f17-700e-443f-a313-f884b8f8ba6e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10180,
            y: 547,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '88374c03-694f-4462-9be9-9134cc74e641',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10273,
            y: 569,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '00aa497b-3af1-44a1-a509-92bc0f055b03',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10368,
            y: 570,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'ac775be2-ce84-493a-b1c3-00259311befa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10467,
            y: 561,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: 'a4a43682-549e-40c3-ac0a-09cb44226288',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 10552,
            y: 522,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'blue_node',
            parent: '3',
            data: '',
        },
        {
            id: '74',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '110',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '164',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '185',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '214',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '219',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '224',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '1b355a2e-d409-489c-8af4-a150c082b42b',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'cropsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '4',
            data: '',
        },
        {
            id: '106',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '160',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '181',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '210',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '215',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '220',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '225',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorA',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '230',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: 'signsSectorB',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '5',
            data: '',
        },
        {
            id: '24b5ebc8-3037-409a-a1cb-8dccad7ec509',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1211,
            y: 61,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: 'e29b386d-82ca-44b6-89a4-89915faab2e6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1268,
            y: 182,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '8172b062-8699-4992-bbc0-0f808a565862',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 944,
            y: 64,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '7cc20243-4f27-40d3-a95f-e018dd6e75dd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1007,
            y: 187,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: 'a75fe524-8e1d-4935-b206-17a7c35bc961',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 683,
            y: 125,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '66bcce8e-c515-423c-aa39-ef070a0cdf54',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 790,
            y: 253,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '5fb8eea7-5483-46eb-8dea-6f32bc1cce5e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 878,
            y: 588,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '1be32a28-4901-4c76-bbdf-3e17a1b5d1fd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 767,
            y: 745,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '36ed6e7e-ff44-471d-a1dc-2755200c8247',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1194,
            y: 565,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: '32b91ceb-0d59-41b6-8d8d-fd56e5d532cd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1069,
            y: 745,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: 'f2437f4c-1d6e-4caf-9612-4526a2213b3c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1429,
            y: 595,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: 'adb2ec91-a455-4b88-a069-12d9e0014ab4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1440,
            y: 769,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '74',
            data: '',
        },
        {
            id: 'a6dc192f-784c-4b4c-bfa3-47f27fce1fb8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1685,
            y: 139,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'c22f5c7d-ed3e-4f37-9032-6343521238f6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1878,
            y: 79,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '2b97f759-93b5-4bb7-afc3-e72fa5546a5a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1955,
            y: 200,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '9946a193-5423-4055-baac-c32022044a96',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2134,
            y: 101,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '24bd898d-4a08-44c6-ad8e-4f6230883f57',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2106,
            y: 545,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'a7d3c1a2-4e11-4d26-bdff-97ca8c452177',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2221,
            y: 647,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'd08cd17e-fe41-4824-8e89-2b470fea741a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2438,
            y: 527,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'c4cebf24-f447-4d2a-b886-9130486e243d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2542,
            y: 640,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'b711bfde-aa9f-4d15-82d5-9d3294fd4d9c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2654,
            y: 756,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'ded13233-bc1e-4b9e-88fc-70519a0ce5db',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2357,
            y: 766,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '52e2314d-c6e1-4923-bc40-0a8d12e77312',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1900,
            y: 673,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '32ea3fd6-4ad2-4d64-b0f5-b1cd607ee542',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1788,
            y: 269,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: '0759c272-c850-419a-9579-44a65630d9a7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1999,
            y: 813,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_4',
            parent: '110',
            data: '',
        },
        {
            id: 'ca980f04-a82a-438d-8d6d-284e5d046596',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3350,
            y: 72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '20d9ad41-cd84-42cf-985f-b24c08257788',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3136,
            y: 76,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '032652c6-dae5-4bad-8ab1-d1b1066f6e32',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2914,
            y: 80,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '6448218e-c2fa-4a87-9697-52f268166fbf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2684,
            y: 85,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'd4f599ff-920e-4247-86e0-f586f73a0558',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3256,
            y: 197,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '6d39d49e-24d8-46cb-be39-17e3c491756d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3040,
            y: 211,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '61b9f5fa-534a-49cb-ac92-6ffda77ba173',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2795,
            y: 223,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'fb15895f-8e89-4c79-8eb5-276a47bf53ae',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2928,
            y: 342,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '27240abf-da60-4618-8de6-d285183b7556',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3718,
            y: 561,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'd7a43cf2-da55-4962-96e6-807b7db8e638',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3526,
            y: 602,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'ed55c62d-ed72-4010-8428-f74b95cbeb2b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3352,
            y: 677,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '2423816a-d515-4b90-8821-799f8ca5c7a0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3213,
            y: 789,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '5e0ca3f9-54a1-4159-ac64-374d984b36e8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3683,
            y: 709,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'bca1eb12-c0d6-4a6e-8371-506169bc7593',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3489,
            y: 795,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '59c3607f-ac53-46ab-86e0-cfa1910b125a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3899,
            y: 675,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'b0211eec-a004-49f2-8531-0c608b372436',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4070,
            y: 785,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: '0da6c5cd-e308-4e08-8fed-6f85843272ef',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3830,
            y: 816,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '164',
            data: '',
        },
        {
            id: 'e861f7cf-43d0-4534-b139-fe82199c286b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4274,
            y: 366,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '1320cf53-ade4-49a7-97c0-768841eb1953',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4877,
            y: 782,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '75d3845a-ad79-457f-a981-1888db49794f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5047,
            y: 682,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '37fad631-39b6-4911-aac1-f5d87084e240',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5223,
            y: 584,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'ea372b25-49d3-4b32-bbda-f35c303b2a46',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5245,
            y: 729,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '0439f020-62dd-4be0-b946-4e42f314be17',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5307,
            y: 865,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '0d29245d-b672-4d1f-841f-6b86dfe083b9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5086,
            y: 839,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '6a1b9959-75e7-4449-977c-013dcddefc64',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4671,
            y: 753,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '9d5a6c11-587a-4110-8983-243fe4de05db',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4816,
            y: 621,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '6b333a0d-d034-44bd-82e9-f775f29d1afd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4999,
            y: 543,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'cd47abe0-aa75-4e88-9e4d-692100cd9b88',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4093,
            y: 90,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'dc9c6d96-997c-4f3f-8347-dac10f0138c3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4263,
            y: 210,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'aea7615d-7335-4a37-ad54-2cab82b15b05',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4083,
            y: 244,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'd2a241f6-b4c1-49c3-a0f2-0de26a140f56',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3903,
            y: 143,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '5e1354ce-628a-456e-a7c6-03847ca017bd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4445,
            y: 245,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'f5e89c42-a65f-45f0-82fd-e2747a9bdd76',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4541,
            y: 105,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: 'ff48a11a-c810-4238-bbba-e04942bc9c2a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4750,
            y: 22,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '085daa19-9e26-4057-ba91-3b2da153ed2b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 4305,
            y: 79,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_4',
            parent: '185',
            data: '',
        },
        {
            id: '5ce8d8b0-2e8e-4f2c-bccb-288e94c28520',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6448,
            y: 41,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '7b1bb024-8e0b-4296-a0e6-e15e97977be3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6748,
            y: 67,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'bb00881a-627e-4156-a236-13e3e357a13d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6846,
            y: 12,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '9fbbb226-c48f-42a6-9ae7-3b2bf7cdee31',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6535,
            y: 154,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '139c02b3-a584-4939-9517-c5da75dae1f8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7124,
            y: 83,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '4d113003-7ec2-4b5e-9ffa-185e6f488f66',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7235,
            y: 26,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'b67a7396-ce32-4afd-aab8-595e396a4662',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7014,
            y: 137,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'ba474c6a-b873-4eea-8650-0b956b94c50a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6901,
            y: 195,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '049731a9-a37b-46dd-a4d2-372565a4aa05',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6790,
            y: 244,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '866dc298-da44-41ea-90dc-8c66ab39c62f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6679,
            y: 297,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'fb553f9f-c67e-4213-918a-d0bdaf87d1b3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6850,
            y: 411,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'b0bc19d3-e7b8-40a5-b0c7-421944ae2b3f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6961,
            y: 373,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '01ce77ff-9df3-4fe2-a4e0-de62f6b59dd2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6315,
            y: 500,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '0ca60784-5f33-44ec-b4d9-d9ea780b0364',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6496,
            y: 613,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '37d1594e-222b-460b-9468-636c336eed61',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6659,
            y: 695,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'c02d58a9-6764-4c98-8659-d0217c037ff2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6574,
            y: 793,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'bcf27da3-f38c-4c8a-ad53-dba3e3df0625',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6391,
            y: 677,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '60094184-69dc-4747-ae87-bdb32e6d95bc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6293,
            y: 753,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '7f31a107-90ab-4651-8380-1a88702495a3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6219,
            y: 841,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '7990502e-5a39-40bf-880c-0607d01734d0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6210,
            y: 563,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'b7c498f6-2735-4fee-a68c-2f05bdfa0522',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6100,
            y: 628,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'd3722e78-f762-4d2b-8333-0804ad94156b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6002,
            y: 703,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'ad3c0c56-2ee8-4b74-ae60-695ae2643288',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5930,
            y: 796,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '285b11f3-01eb-4153-ac41-f205e3edcaad',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7057,
            y: 328,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'e743a0cd-2555-417c-b14b-c8261c3e2d61',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7165,
            y: 283,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '991eb537-f7da-45ce-8b6b-b9d6d84bf574',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7268,
            y: 235,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: '44baa819-4e90-49c5-8547-a46272267828',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7367,
            y: 179,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'd3793d9d-098c-4378-99fd-0c7eb79c5247',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6641,
            y: 110,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '214',
            data: '',
        },
        {
            id: 'c359f38d-1d25-4334-892b-5c4a88ab51ba',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7605,
            y: 106,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'ef0c6636-c8e1-45d5-8334-f30f45d5df9a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7735,
            y: 106,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '615d5738-215a-4f8e-a510-fae38dbe1a40',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7873,
            y: 120,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'cbf9dac5-0358-4c5f-b9e2-bef65d43a6d3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8005,
            y: 148,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '33ed4843-85be-4db1-af09-372c47f7ac66',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7753,
            y: 418,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'b89e5470-b631-428b-96a8-8238382777cf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7644,
            y: 480,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '00f92864-e212-4034-82b2-f6eb8e6214fd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7533,
            y: 534,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '4c239773-e081-4a58-9690-febe30dd96a8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7427,
            y: 599,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '274d65a8-6798-4727-b51f-86c4b34d50a9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7316,
            y: 658,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '04e9abdd-24c6-49d5-b613-7975103f2ad4',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7196,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'efa1c099-1a66-4d84-8903-6ccc6ef5b4e2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7936,
            y: 512,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '99345f94-e716-45a8-be4e-9b7b43dbf6dc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7834,
            y: 578,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '3efb0371-1394-4212-81e9-83f3a63036b7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7723,
            y: 635,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '4351f4f0-c2fd-43eb-8828-81c4b3b9d6c8',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7605,
            y: 711,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '13f8eb79-7ef0-4c6b-b6d8-8f688eed1075',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7495,
            y: 795,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '29bd73a4-5e48-40b6-81aa-beb5daee4886',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8085,
            y: 624,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '3842dd53-bd97-4150-8284-e45ba8f34a59',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7995,
            y: 686,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'ffb23655-8477-4874-a04c-3325d8a09d8d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7913,
            y: 754,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: '8ae31247-d0d2-47b6-8edf-1e1a6065a3b0',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7820,
            y: 827,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'b4529a8b-dd2b-4fa0-a4f6-b46b0541e90f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8063,
            y: 29,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_4',
            parent: '219',
            data: '',
        },
        {
            id: 'bb88d2cc-bab9-4bc6-808f-476ebcde73bf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8252,
            y: 175,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '2b121655-66ec-475d-a490-813634093e8d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8337,
            y: 129,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'ce7ebb75-f368-424c-8878-de42b6a980bc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8427,
            y: 92,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'b1250e84-f2f3-4432-b54f-9975d8fe0904',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8516,
            y: 52,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'd4c59ce0-9754-4ca1-bee1-c9ccc71098a3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8612,
            y: 17,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '352431a9-92c9-491f-b5b6-f97b9bfcc9cd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8384,
            y: 265,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '9c5ff5cb-4a3a-4bb7-9545-c5daf5d71e0f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8459,
            y: 370,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '53208fc7-5838-4335-8ca0-3afbaba9a839',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8489,
            y: 762,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '60eb83fb-6616-447b-9f77-3af40e669eaf',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8691,
            y: 696,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '0caf94b9-b6fb-4191-bf74-980e1f8b2900',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8743,
            y: 761,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '39f6d632-3f4d-4570-8a3b-0e645d67d894',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8895,
            y: 601,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '37fe02d0-5fbb-43d9-9b7c-3076035c4539',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8949,
            y: 668,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '8831968c-7e5c-41a0-beba-9516669f1452',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9016,
            y: 737,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'f807d5c5-6857-4d13-835c-a6446a2c5f74',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9084,
            y: 805,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'f0ef9992-ca6b-41ae-9eb6-873729604431',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8549,
            y: 325,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '3dfd1b79-d8e7-4b1a-ab0b-60a92547543c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8639,
            y: 280,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '259137be-392d-48b2-ab16-6eb50bc67650',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8729,
            y: 242,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'e1e74469-0236-48bd-8df3-7fb5f2f33a1b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8816,
            y: 204,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'db2dd3b3-0d6c-4f9e-81ab-21e0c30937d7',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8904,
            y: 170,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '42ba515e-b844-4591-9912-a5d58b887860',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8993,
            y: 130,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: 'ed9f3cf0-956e-4d87-a413-aeef22b6dd08',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8474,
            y: 214,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '4ea99281-a2a1-49f4-aa91-46adccd189d2',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8567,
            y: 176,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '803d0212-9998-490e-a732-68f30b5ea562',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8661,
            y: 136,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '065026b5-031a-42f4-b0c6-5dbed63e115a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8757,
            y: 97,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '3ee7b91f-8b6e-406f-93f0-42499e3ff586',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8850,
            y: 53,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '224',
            data: '',
        },
        {
            id: '02ff52c2-aa97-49bd-8a79-a20e9e60c234',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9629,
            y: 50,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'a9bdcb93-a4ee-41d2-9b3f-7b5769047877',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9431,
            y: 55,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'bf3e419d-33fd-47ac-a88c-1fb3e1d5cecc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9353,
            y: 190,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '663fe2fc-b9ac-4cb1-8a03-420ecf87b1c6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9726,
            y: 497,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '28afc853-95b5-4965-a0fa-cb1d9e4f4f82',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9784,
            y: 565,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'f4fc2e9a-1ec7-4aa5-9710-68d8cad29ad3',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9843,
            y: 633,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '1b41bbbe-c5d5-451f-92b1-4c2a7b217809',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9898,
            y: 708,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '6ee00434-ffe5-46ff-854c-3466e9b5d3ae',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9562,
            y: 592,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '869bb937-8977-4129-9456-aa40214d582b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9619,
            y: 662,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '37581036-003a-490e-a8cd-817b6ef362b1',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9676,
            y: 730,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '3dddf8a4-2b6b-42d1-81f4-1d206997f02a',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9730,
            y: 803,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '794bd60d-d4cf-4785-8ed4-5a3cebad0b98',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9396,
            y: 684,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '051c543a-7b52-441d-8058-ff76d5cdba9f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9448,
            y: 759,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'e68f5c5f-d350-46c0-befc-1b47055a8600',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9958,
            y: 780,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '45d1e2b6-7adf-4ba9-badd-800dc6776b0f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9279,
            y: 122,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: 'd2a2b837-fc5a-4701-8d70-c2639a4a8023',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9197,
            y: 63,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '703992ea-ae18-4c2d-a06f-5138f6728ebd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9501,
            y: 116,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.5,
                y: 0.5,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_4',
            parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
            data: '',
        },
        {
            id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 1142,
            y: 563,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '106',
            data: '',
        },
        {
            id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 2350,
            y: 368,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '160',
            data: '',
        },
        {
            id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 3759,
            y: 522,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '181',
            data: '',
        },
        {
            id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 5112,
            y: 424,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '210',
            data: '',
        },
        {
            id: '107',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 6160,
            y: 490,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '215',
            data: '',
        },
        {
            id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 7844,
            y: 452,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '220',
            data: '',
        },
        {
            id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 8918,
            y: 556,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '225',
            data: '',
        },
        {
            id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 9790,
            y: 514,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'crop-sign',
            parent: '230',
            data: '',
        },
        {
            id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            data: '',
        },
        {
            id: '85746295-e987-4e2b-a7d0-6791216b55a9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -27,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_harvest_map',
            parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
            data: '',
        },
        {
            id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            data: '',
        },
        {
            id: '656a5808-34d6-4751-a733-6af98d163ac6',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'coconut_harvest_map',
            parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
            data: '',
        },
        {
            id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            data: '',
        },
        {
            id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_harvest_map',
            parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
            data: '',
        },
        {
            id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            data: '',
        },
        {
            id: '958851db-006d-425c-afff-a85018a3cb2b',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'dragonfruit_harvest_map',
            parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
            data: '',
        },
        {
            id: '108',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '107',
            data: '',
        },
        {
            id: '109',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_harvest_map',
            parent: '107',
            data: '',
        },
        {
            id: '46aeb65d-4896-4557-9865-75ef0057e163',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            data: '',
        },
        {
            id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'waterspinach_harvest_map',
            parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
            data: '',
        },
        {
            id: '03074616-c479-4d19-9e8c-855582627513',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            data: '',
        },
        {
            id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_harvest_map',
            parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
            data: '',
        },
        {
            id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -20,
            y: -72,
            anchor: {
                x: 0.5,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: false,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'speech_bubble',
            parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            data: '',
        },
        {
            id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -5,
            y: -24,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 0.6,
                y: 0.6,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'calabash_harvest_map',
            parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
            data: '',
        },
    ],
    version: '1.0.x',
} as const;

export class WorldLayout23 {
    static raw = raw;
    root: PIXI.Container;
    backgrounds: PIXI.Container;
    nodesContainer: PIXI.Container;
    cropsSectorA: PIXI.Container[];
    cropsSectorB: PIXI.Container[];
    signsSectorA: PIXI.Container[];
    signsSectorB: PIXI.Container[];

    constructor() {
        populate(this, raw);
    }
}
